import React from "react";
import { Link } from "react-router-dom";
import "./MirrorOfTheMindModule.css";
import { useLanguage } from "../shared/LanguageContext";

function MirrorOfTheMindModule() {
  const { language, t } = useLanguage();
  const isSpanish = language === "es";
  const paymentLink = isSpanish
    ? process.env.REACT_APP_STRIPE_PAYMENT_LINK_ES
    : process.env.REACT_APP_STRIPE_PAYMENT_LINK;

  return (
    <main className="aur-homepage" data-testid="aur-homepage">
      <div
        className="aur-homepage__container"
        data-testid="aur-homepage-container"
      >
        <span
          id="top"
          className="aur-homepage__scroll-anchor"
          aria-hidden="true"
        />

        <img
          src={isSpanish ? "/aur-book/aur-homepage-es.jpg" : "/aur-book/aur-homepage.png"}
          alt={isSpanish ? "AUR — El Espejo de la Mente" : "AUR — The Mirror of the Mind"}
          className="mirror-home-artwork"
          draggable="false"
        />

        {/* TOP NAVIGATION — calibrated to 864×1920 artwork */}

        <Link
          to="/mirror-of-the-mind"
          className="aur-homepage__overlay"
          data-testid="nav-home"
          aria-label={t("home")}
          style={isSpanish ? { top: "1.55%", left: "31.4%", width: "5.1%", height: "1.7%" } : { top: "1.05%", left: "32.5%", width: "5.8%", height: "1.9%" }}
        />

        <Link
          to="/mirror-of-the-mind/about"
          className="aur-homepage__overlay"
          data-testid="nav-about"
          aria-label={t("about")}
          style={isSpanish ? { top: "1.55%", left: "38.7%", width: "8.1%", height: "1.7%" } : { top: "1.05%", left: "39.6%", width: "5.9%", height: "1.9%" }}
        />

        <Link
          to="/mirror-of-the-mind/book"
          className="aur-homepage__overlay"
          data-testid="nav-preview"
          aria-label={t("preview")}
          style={isSpanish ? { top: "1.55%", left: "48.5%", width: "10.2%", height: "1.7%" } : { top: "1.05%", left: "46.7%", width: "7.4%", height: "1.9%" }}
        />

        <Link
          to="/mirror-of-the-mind/book/product"
          className="aur-homepage__overlay"
          data-testid="nav-product-info"
          aria-label={t("productInfo")}
          style={isSpanish ? { top: "1.55%", left: "59.7%", width: "17.5%", height: "1.7%" } : { top: "1.05%", left: "55.6%", width: "12.2%", height: "1.9%" }}
        />

        <Link
          to="/legal/contact"
          className="aur-homepage__overlay"
          data-testid="nav-support"
          aria-label={t("support")}
          style={isSpanish ? { top: "1.55%", left: "77.7%", width: "5.1%", height: "1.7%" } : { top: "1.05%", left: "72.0%", width: "7.2%", height: "1.9%" }}
        />

        <a
          href={paymentLink}
          target="_blank"
          rel="noopener noreferrer"
          className="aur-homepage__overlay"
          data-testid="nav-purchase"
          aria-label={t("purchase")}
          style={isSpanish ? { top: "0.85%", left: "83.0%", width: "14.0%", height: "3.0%" } : { top: "0.65%", left: "81.1%", width: "16.0%", height: "3.4%" }}
        />

        {/* HERO */}

        <Link
          to="/mirror-of-the-mind/book"
          className="aur-homepage__overlay"
          data-testid="hero-view-the-book"
          aria-label={t("viewBook")}
          style={isSpanish ? { top: "30.1%", left: "5.5%", width: "30.8%", height: "3.9%" } : { top: "29.0%", left: "4.5%", width: "32.0%", height: "3.4%" }}
        />

        {/* ABOUT / FEATURE SECTION */}

        <span
          id="about-section"
          className="aur-homepage__scroll-anchor"
          style={{ top: "60%" }}
          aria-hidden="true"
        />

        {/* Preview the Book, Product Information, Secure Purchase, Instant Digital Access
            — overlays disconnected pending coordinate calibration */}

        {/* FOOTER LEGAL NAVIGATION — SURGICAL WORD-ALIGNMENT CORRECTION */}

        <Link
          to="/legal/terms"
          className="aur-homepage__overlay"
          data-testid="footer-terms"
          aria-label={isSpanish ? "Términos de uso" : "Terms of Use"}
          style={isSpanish
            ? { top: "91.8%", left: "26.0%", width: "8.0%", height: "1.6%" }
            : { top: "91.8%", left: "26.0%", width: "8.0%", height: "1.6%" }}
        />

        <Link
          to="/legal/privacy"
          className="aur-homepage__overlay"
          data-testid="footer-privacy"
          aria-label={isSpanish ? "Privacidad" : "Privacy"}
          style={isSpanish
            ? { top: "91.8%", left: "36.4%", width: "5.4%", height: "1.6%" }
            : { top: "91.8%", left: "36.4%", width: "5.4%", height: "1.6%" }}
        />

        <Link
          to="/legal/digital-product-information"
          className="aur-homepage__overlay"
          data-testid="footer-digital-product-info"
          aria-label={isSpanish ? "Información del producto digital" : "Digital Product Information"}
          style={isSpanish
            ? { top: "91.8%", left: "44.2%", width: "16.4%", height: "1.6%" }
            : { top: "91.8%", left: "44.2%", width: "16.4%", height: "1.6%" }}
        />

        <Link
          to="/legal/copyright"
          className="aur-homepage__overlay"
          data-testid="footer-copyright"
          aria-label="Copyright"
          style={isSpanish
            ? { top: "91.8%", left: "63.1%", width: "5.5%", height: "1.6%" }
            : { top: "91.8%", left: "63.1%", width: "5.5%", height: "1.6%" }}
        />

        <Link
          to="/legal/contact"
          className="aur-homepage__overlay"
          data-testid="footer-contact-support"
          aria-label={isSpanish ? "Contacto / Soporte" : "Contact / Support"}
          style={isSpanish
            ? { top: "91.8%", left: "71.1%", width: "10.3%", height: "1.6%" }
            : { top: "91.8%", left: "71.1%", width: "10.3%", height: "1.6%" }}
        />
      </div>
    </main>
  );
}

export default MirrorOfTheMindModule;
